import { u as n } from "./header.context.gmG2mr37.js";
const r = (i) => {
  const { erWaitTimes: t } = n();
  let e;
  return i && (e = t == null ? void 0 : t.find((o) => o.title === i)), e;
};
export {
  r as u
};
